import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { CustomUIConfirmAlerter } from 'common/Alerters/customUiAlerters/CustomUIConfirmAlerter';

export const confirmAlerter = (config, successCallback) => confirmAlert({
    overlayClassName: 'pop-up-overlay',
    customUI: ({ onClose }) => <CustomUIConfirmAlerter { ...{ onClose, config, successCallback } } />,
});
